export default __webpack_public_path__ + "static/media/why-babcock-square.b6e2e931.mp4";